module.exports = __webpack_public_path__ + "img/handshake-subscription.5f0b3098.svg";